import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import styles from './Tag.module.css'

export interface TagProps extends HTMLAttributes<HTMLDivElement> {}

export default function Tag({ children, className, ...props }: TagProps) {
	return (
		<div className={clsx(styles.root, className)} {...props}>
			{children}
		</div>
	)
}
